// extracted by mini-css-extract-plugin
export var alignBaseline = "_t-9";
export var alignCenter = "_t-5";
export var alignFlexEnd = "_t-7";
export var alignFlexStart = "_t-6";
export var alignSelfBaseline = "_t-e";
export var alignSelfCenter = "_t-a";
export var alignSelfFlexEnd = "_t-c";
export var alignSelfFlexStart = "_t-b";
export var alignSelfStretch = "_t-d";
export var alignStretch = "_t-8";
export var column = "_t-2";
export var columnReverse = "_t-4";
export var flex = "_t-0";
export var justifyCenter = "_t-f";
export var justifyFlexEnd = "_t-h";
export var justifyFlexStart = "_t-g";
export var justifySpaceAround = "_t-j";
export var justifySpaceBetween = "_t-i";
export var justifySpaceEvenly = "_t-k";
export var row = "_t-1";
export var rowReverse = "_t-3";
export var wrapNowrap = "_t-m";
export var wrapWrap = "_t-l";
export var wrapWrapReverse = "_t-n";